module.exports = __webpack_public_path__ + "static/img/BA@2x.77bf6431.jpg";